export default __webpack_public_path__ + "static/image1-3517ba1e2a8aafb28f9a83f572848796.jpg";